import React from 'react';
import MembershipStatusPanel from "./MembershipStatusPanel";
import EfnLogo from "../logos/EfnLogo";
import './Homepage.css';
import LoginOrLogoutButton from "../components/LoginOrLogoutButton";

const Home = () => {
    const deploymentMarker = (process.env.REACT_APP_DEPLOYMENT_MARKER || '').trim();

    return (
        <div className="page-shell">
            <div className="toplevel">
                <EfnLogo className="toplevel-logo"/>
                {deploymentMarker && (
                    <div className="deployment-marker" aria-label={`Deployment marker: ${deploymentMarker}`}>
                        {deploymentMarker}
                    </div>
                )}
                <h1 className="efn-name-in-header">Elektronisk Forpost Norge</h1>
                <LoginOrLogoutButton/>
                <MembershipStatusPanel/>
            </div>
        </div>
    );
};

export default Home;
